import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const GraButton = styled(Link)`
    width: 120px;
    height: 36px;
    background: #F879431A;
    border: 1px solid #F879434D;
    font-size: 14px;
    font-weight: 700;
    color: #F87943;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    //&:hover {
    //    background: linear-gradient(
    //            0deg,
    //            rgba(255, 255, 255, 0.3) 0%,
    //            rgba(255, 255, 255, 0.3) 100%
    //    ),
    //    linear-gradient(90deg, #38c4f6 0%, #e10ff0 100%);
    //}
`
